import { getCookie } from '../utils/domUtils';

declare global {
  interface Window {
    fetchFullstory: Function;
    fetchFacebook: Function;
    fetchLinkedin: Function;
    fetchTwitter: Function;
    fbq: any | undefined;
  }
}

export function startProviders() {
  try {
    const cookieString: string = getCookie('cookies_policy');
    if (cookieString) {
      // temporary stop log rocket because of a potential impact on search
      // startLogRocket();
      window.fetchFullstory();
      window.fetchFacebook();
      window.fetchLinkedin();
      window.fetchTwitter();
    }
    if (window.fbq && window.page_name === 'Signup') {
      /* 
        Redundancy of this event with SignUpLayout
        component does not communicate with cookie acceptance
        triggers pixel if cookie is accepted on the page
      */
      window.fbq('track', 'ViewContent');
    }
  } catch (error) {
    console.log(error);
  }
}
